const borderRadiuses = {
  none: "0",
  xs: "0.125rem",
  // 2px
  sm: "0.25rem",
  // 4px
  md: "0.5rem",
  // 8px
  lg: "0.625rem",
  // 10px
  xl: "1rem",
  // 16px
  "2xl": `1.5rem`,
  // 24px
  "3xl": `2rem`,
  // 32px
  full: "9999px"
};

export { borderRadiuses };
